import makeStyles from '@mui/styles/makeStyles';

const useStyles = makeStyles((theme) => ({
    root: {
        paddingLeft: 10,
        paddingRight: 10,
        marginBottom: 5
    },
    horizontalSpacedContainer: {
        marginLeft: 5,
        marginRight: 5,
    },
    spacedContainer: {
        marginLeft: 10,
        marginRight: 10,
        marginTop: 8
    }
}));

export {useStyles};
